export default __webpack_public_path__ + "static/media/DashGetReady.1a11a718.svg";